import { colors } from "../../colors";
import type { InputSize, InputStyleProps, InputVariant } from "./types";

// Default size styles
export const getInputSizeStyles = (size: InputSize): string => {
  switch (size) {
    case "small":
      return `
        padding: 10px 12px !important;
        font-size: 0.9em;
        line-height: 20px;
      `;
    case "large":
      return `
        padding: 15px 20px !important;
        font-size: 1.2em;
        line-height: 28px;
      `;
    case "medium":
    default:
      return `
        padding: 10px 14px !important;
        font-size: 1em;
        line-height: 24px;
      `;
  }
};

// Default variant styles
export const getInputVariantStyles = (
  variant: InputVariant,
  error: boolean,
  styleProps?: InputStyleProps,
): string => {
  const {
    backgroundColor,
    focusBackgroundColor,
    errorBackgroundColor,
    borderColor,
    focusBorderColor,
    errorBorderColor,
    color,
    placeholderColor,
  } = styleProps ?? {};

  const getErrorStyles = () => {
    if (!error) return "";
    return `
      border-color: ${errorBorderColor ?? colors.error} !important;
      background-color: ${errorBackgroundColor ?? backgroundColor ?? "inherit"};
    `;
  };

  switch (variant) {
    case "outline":
      return `
        background-color: ${backgroundColor ?? colors.white};
        border-color: ${borderColor ?? colors.gray[300]} !important;
        color: ${color ?? "inherit"};

        &:focus {
          border-color: ${focusBorderColor ?? colors.primary[300]} !important;
          background-color: ${focusBackgroundColor ?? backgroundColor ?? colors.white};
        }

        &::placeholder {
          color: ${placeholderColor ?? colors.gray[400]};
        }

        ${getErrorStyles()}
      `;
    case "filled":
      return `
        background-color: ${backgroundColor ?? colors.gray[100]};
        border-color: ${borderColor ?? colors.transparent} !important;
        color: ${color ?? "inherit"};

        &:focus {
          border-color: ${focusBorderColor ?? colors.primary[300]};
          background-color: ${focusBackgroundColor ?? colors.white};
        }

        &::placeholder {
          color: ${placeholderColor ?? colors.gray[400]};
        }

        ${getErrorStyles()}
      `;
    default:
      return "";
  }
};
